/*
  Puntos de posicion de la galeria, en movil.

  Esto era un <script> en linea dentro de product-media-gallery.liquid y se
  ejecutaba una sola vez, al cargar la pagina. Desde que el selector de color
  repinta la seccion del producto sin recargar, eso ya no sirve: el HTML nuevo
  se inserta con el DOM, y los <script> que vengan dentro NO se ejecutan. Los
  puntos aparecian pintados pero muertos, o no aparecian.

  Como custom element se arregla solo: el navegador llama a connectedCallback
  cada vez que el elemento entra en el documento, tambien cuando entra en un
  repintado. La clase se define una vez, desde este archivo, que se carga
  aparte y por tanto siempre se ejecuta.
*/
(function () {
  if (customElements.get('av-puntos-galeria')) return;

  customElements.define(
    'av-puntos-galeria',
    class extends HTMLElement {
      connectedCallback() {
        // Al insertarse en un repintado, el elemento puede conectarse antes de
        // que sus hermanos esten en el arbol. Un reintento en el siguiente
        // fotograma basta; mas de uno significaria que la galeria no existe.
        if (!this.montar()) requestAnimationFrame(() => this.montar());
      }

      montar() {
        if (this.montado) return true;

        const galeria = this.closest('media-gallery');
        if (!galeria) return false;
        const visor = galeria.querySelector('slider-component[id^="GalleryViewer"]');
        const lista = galeria.querySelector('.product__media-list');
        if (!visor || !lista) return false;

        const slides = Array.from(lista.querySelectorAll('.product__media-item'));
        // Con una sola foto no hay nada que indicar. Se marca como montado para
        // no reintentar en cada fotograma.
        if (slides.length < 2) {
          this.montado = true;
          return true;
        }
        this.montado = true;

        slides.forEach((slide, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'av-punto' + (i === 0 ? ' av-punto--activo' : '');
          b.setAttribute('aria-label', 'Ir a la imagen ' + (i + 1) + ' de ' + slides.length);
          b.addEventListener('click', () => {
            lista.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
          });
          this.appendChild(b);
        });
        this.classList.add('av-puntos--listo');

        const puntos = Array.from(this.children);
        const marcar = (i) => {
          if (i < 0 || i >= puntos.length) return;
          for (let k = 0; k < puntos.length; k++) {
            puntos[k].classList.toggle('av-punto--activo', k === i);
          }
        };

        visor.addEventListener('slideChanged', (e) => {
          const p = (e.detail && e.detail.currentPage) || 1;
          marcar(p - 1);
        });

        let t;
        lista.addEventListener(
          'scroll',
          () => {
            clearTimeout(t);
            t = setTimeout(() => {
              const paso = slides[1].offsetLeft - slides[0].offsetLeft;
              if (paso > 0) marcar(Math.round(lista.scrollLeft / paso));
            }, 60);
          },
          { passive: true }
        );

        return true;
      }
    }
  );
})();
